import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Tag, Button } from "antd";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../styles/whatsappcloudreportdetails.css";
import qs from "qs";
import { handleApiError } from "../utils/errorHandler";

const getRandomuserParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const WhatsappCloudReportFailedDetails = () => {
  const { id } = useParams();
  const location = useLocation();

  const navigate = useNavigate();
  const { campaignId } = location.state || {};
  const [tabledata, setTableData] = useState([]);
  const [showLoader, setShowLoader] = useState();

  // State to track the selected category
  const [selectedCategory, setSelectedCategory] = useState("all");

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const fetchCampaignReportsData = async () => {
    try {
      setShowLoader(true);
      const response = await axios.get(
        `/api/campaignscheduler/webhookresponse/${id}?${qs.stringify(
          getRandomuserParams(tableParams)
        )}`
      );

      const whatsappResponses = response.data?.whatsappResponses || [];

      // Map data for AntD table
      const mappedData = whatsappResponses.map((item, index) => ({
        // key: item._id || index,
        key: item._id ? String(item._id) : `row-${index}`,
        whatsappMobile: item.whatsappMobile,
        status: item.status,
        message: item?.response?.error?.message || "-",
        details: item?.response?.error?.error_data?.details || "-",
        timestamp: item.timestamp,
      }));

      // sort by latest timestamp
      const sortedData = mappedData.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      setTableData(sortedData);
    } catch (error) {
      console.error("Error fetching campaign data:", error);
      handleApiError(error, "Error fetching campaign data");
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    fetchCampaignReportsData();
  }, [JSON.stringify(tableParams)]);

  const columns = [
    {
      title: "WhatsApp Mobile",
      dataIndex: "whatsappMobile",
      key: "whatsappMobile",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        let color;
        switch (status) {
          case "Sent":
            color = "blue";
            break;
          case "Delivered":
            color = "orange";
            break;
          case "Read":
            color = "green";
            break;
          case "Failed":
            color = "red";
            break;
          default:
            color = "gray";
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
      align: "center",
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      ellipsis: true,
      align: "center",
      render: (text = "") => {
        const words = text.split(" ");
        const formatted = [];

        for (let i = 0; i < words.length; i += 20) {
          formatted.push(words.slice(i, i + 20).join(" "));
        }

        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              textAlign: "left",
              color: "#CF1322",
            }}
          >
            {formatted.join("\n")}
          </div>
        );
      },
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      align: "center",
      render: (text) => {
        if (!text) return "N/A";
        const dateObj = new Date(text);
        const date = dateObj.toLocaleDateString("en-GB");
        const time = dateObj.toLocaleTimeString();
        return (
          <div style={{ textAlign: "center" }}>
            <div>{date}</div>
            <div>{time}</div>
          </div>
        );
      },
    },
  ];

  const refreshTable = () => {
    console.log("Table refreshed!");

    // Show loader immediately
    setShowLoader(true);

    // Call the fetch function with a delay of 1 second
    setTimeout(async () => {
      await fetchCampaignReportsData(); // Ensure the fetch function completes
      setShowLoader(false); // Hide loader after the data is fetched
    }, 1000);
  };

  // Filter the data based on the selected category
  const filteredData = () => {
    switch (selectedCategory) {
      case "sent":
        return tabledata.filter((item) => item.status === "sent");
      case "delivered":
        return tabledata.filter((item) => item.status === "delivered");
      case "read":
        return tabledata.filter((item) => item.status === "read");
      case "failed":
        return tabledata.filter((item) => item.status === "failed");
      default:
        return tabledata;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setTableData([]);
    }
  };

  const getDataSource = () => {
    return tabledata;
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">
                Campaign Name : {campaignId ? `${campaignId}` : "Loading..."}
              </h4>
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)} // Go back to the previous page
              >
                ← Back
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="container my-5">
          {/* <h6>Table reports</h6> */}
          <div className="d-flex align-items-center gap-2">
            <div>
              <h6>Quick reports</h6>
            </div>
            <div
              id="refresh-btn"
              style={{ fontSize: "25px" }}
              onClick={refreshTable}
            >
              <i className="ri-refresh-line"></i>
            </div>
          </div>

          <div className="row">
            <div className="col-xxl-12">
              <div id="contactList" className="card">
                <div className="card-header py-3">
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="d-flex flex-wrap flex-grow-1 gap-2">
                      {/* Name */}
                    </div>
                    <div className="flex-shrink-0">
                      {/* {failedTable ? (
                        <>
                          <div className="dropdown">
                            <button
                              className="btn btn-primary d-flex align-items-center gap-2 dropdown-toggle"
                              type="button"
                              id="dropdownFilterButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Filter
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownFilterButton"
                            >
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("All")}
                                >
                                  All
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleFilterClick("Message undeliverable")
                                  }
                                >
                                  Message undeliverable
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("Error 2")}
                                >
                                  Error 2
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => handleFilterClick("Error 3")}
                                >
                                  Error 3
                                </button>
                              </li>
                            </ul>
                          </div>
                        </>
                      ) : (
                        ""
                      )} */}
                      {/* <button
                        className="btn btn-success btn-sm"
                        onClick={handleDownloadCSV}
                        type="primary"
                      >
                        Download
                        {selectedCategory.charAt(0).toUpperCase() +
                          selectedCategory.slice(1)}{" "}
                        Data
                      </button> */}
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2 align-item-center"></div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <Table
                    dataSource={getDataSource()}
                    columns={columns}
                    rowKey="_id"
                    loading={showLoader}
                    scroll={{ x: true }}
                    style={{
                      overflowX: tabledata.length > 5 ? "scroll" : "hidden",
                    }}
                    pagination={{
                      pageSize: tableParams.pagination.pageSize,
                      position: "bottomRight",
                      showSizeChanger: true,
                      showQuickJumper: true,
                      pageSizeOptions: ["5", "10", "15", "20", "50", "100"],
                    }}
                    onChange={handleTableChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappCloudReportFailedDetails;
